import React, { useState } from 'react';
import styles from './MediaPage.module.css';
import { Headphones, Book, Youtube, Video, FileText, LibraryBig } from 'lucide-react';
import BooksContent from "../content/BooksContent";
import AudioContent from "../content/AudioContent";
import VideoContent from "../content/VideoContent";
import ShortsVideoContent from "../content/ShortsVideoContent";
import BlogContent from '../content/BlogContent';
import { useAdminSettings } from '../../../hooks/admin/useAdminSettings';
import useAuthStore from '../../../store/authStore';
import SeriesAdmin from '../content/SeriesAdmin';


function MediaPage() {
  const [activeComponent, setActiveComponent] = useState(null);
  const { settingsData, isLoading: isLoadingSettings } = useAdminSettings();
  const { user } = useAuthStore();
  

  const getAllMediaCategories = () => [
    { 
      name: 'Series', 
      icon: <LibraryBig className={styles.icon} />, 
      component: <SeriesAdmin />,
      settingKey: 'playlistsection'
    },
    { 
      name: 'Audio', 
      icon: <Headphones className={styles.icon} />, 
      component: <AudioContent />,
      settingKey: 'audiosection'
    },
    { 
      name: 'eBooks', 
      icon: <Book className={styles.icon} />, 
      component: <BooksContent />,
      settingKey: 'bookssection'
    },
    { 
      name: 'Videos', 
      icon: <Youtube className={styles.icon} />, 
      component: <VideoContent />,
      settingKey: 'videosection'
    },
    { 
      name: 'Shorts', 
      icon: <Video className={styles.icon} />, 
      component: <ShortsVideoContent />,
      settingKey: 'shortvideosection'
    },
    { 
      name: 'Blogs', 
      icon: <FileText className={styles.icon} />, 
      component: <BlogContent />,
      settingKey: 'blogPosts'
    }
  ];

  const getVisibleCategories = () => {
    const allCategories = getAllMediaCategories();
    
    // Super admin sees everything
    if (user?.role === "super_admin") {
      return allCategories;
    }
    
    // Regular admin sees based on settings
    if (user?.role === 'admin') {
      return allCategories.filter(category => 
        settingsData?.[category.settingKey] === true
      );
    }
    
    // Default case: show nothing
    return [];
  };

  const handleSelection = (component) => {
    setActiveComponent(component);
  };

  const renderMainContent = () => {
    if (isLoadingSettings) {
      return <div className={styles.loading}>Loading...</div>;
    }

    const visibleCategories = getVisibleCategories();

    if (!activeComponent) {
      return (
        <div className={styles.gridContainer}>
          {visibleCategories.map((category, index) => (
            <div
              key={index}
              className={styles.card}
              onClick={() => handleSelection(category.component)}
            >
              <div className={styles.iconContainer}>
                {category.icon}
              </div>
              <h2 className={styles.categoryName}>{category.name}</h2>
            </div>
          ))}
        </div>
      );
    }
    
    return (
      <div className={styles.componentContainer}>
        <button 
          className={styles.backButton}
          onClick={() => setActiveComponent(null)}
        >
          ← Back to Categories
        </button>
        {activeComponent}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Media Center</h1>
      {renderMainContent()}
    </div>
  );
}

export default MediaPage;